import apiClient from "../../api/api";

/**
 * @description Fetches the user status list filtered by manager and optionally by project.
 * The request returns a paginated list with a fixed limit.
 *
 * @async
 * @function requestGetUserStatus
 * @param {number} managerId - The manager ID used to filter the user status.
 * @param {number} projectId - The project ID used to further filter the user status when greater than zero.
 *
 * @returns {Promise<any>} A promise that resolves with the user status data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestGetUserStatus = async(managerId, projectId) => {
    const params = {
        managerId: managerId,
        limit: 1000
    }
    if(projectId > 0){
        params.projectId = projectId
    }

    const getUserStatusResponse = await apiClient.get(import.meta.env.VITE_GET_USER_STATUS, { params, timeout: 90000 })

    return getUserStatusResponse.data

}

/**
 * @description Fetches the current version of the Wisdom Tracker application.
 *
 * @async
 * @function requestGetCurrentTrackerVersion
 * @returns {Promise<any>} A promise that resolves with the current tracker version data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestGetCurrentTrackerVersion = async() => {
    const getVersionResponse = await apiClient.get(import.meta.env.VITE_GET_WISDOM_TRACKER_VERSION)

    return getVersionResponse.data
}